// Mock data for Eden Remedies E-commerce Clone

export const siteConfig = {
  name: "Eden Remedies",
  tagline: "Happy Holidays from everyone at Eden Remedies!",
  logo: "eden",
};

export const categories = [
  { id: "moisturizers", name: "Moisturizers", slug: "moisturizers" },
  { id: "serums", name: "Serums", slug: "serums" },
  { id: "cleansers", name: "Cleansers", slug: "cleansers" },
  { id: "masks", name: "Masks", slug: "masks" },
];

export const navigation = [
  { name: "SHOP ALL", href: "/products" },
  { name: "ON SALE", href: "/products?sale=true" },
  { name: "NEW ARRIVALS", href: "/products?new=true" },
  { name: "BLOG", href: "/blog" },
];

export const heroSection = {
  title: "Embrace Your Timeless Radiance.",
  description: "Discover the age-defying secret that nature has kept for centuries. Timeless Remedy is a luxurious, all-natural moisturizer crafted to restore, replenish, and reveal your most luminous skin.",
  buttonText: "SHOP THE REMEDY",
  buttonLink: "/products/timeless-remedy",
  image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=800&q=80",
};

export const contentSections = [
  {
    id: 1,
    title: "More Than a Moisturizer. A Ritual.",
    description: "As our skin matures, it tells a story of a life well-lived. But it also deserves profound care and nourishment. We grew tired of harsh chemicals and empty promises. That's why we created Timeless Remedy—a symphony of nature's most potent botanicals, meticulously blended to work in harmony with your skin.\n\nIt's not about erasing time; it's about enriching your skin with the vitality it needs to look and feel its absolute best, today and always.",
    image: "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=800&q=80",
    imagePosition: "right",
    link: "/products",
  },
  {
    id: 2,
    title: "Our Timeless Commitment",
    description: null,
    commitments: [
      { icon: "check", text: "Pure & Potent: We source the highest quality botanicals for maximum efficacy." },
      { icon: "check", text: "Always Cruelty-Free: Certified Leaping Bunny. We love animals as much as we love great skin." },
      { icon: "check", text: "Sustainably Sourced: Packaged in recyclable glass to honor and protect our planet." },
      { icon: "check", text: "Formulated Without: Parabens, sulfates, phthalates, synthetic fragrances, or harsh chemicals." },
    ],
    image: "https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=800&q=80",
    imagePosition: "left",
    link: "/products",
  },
];

export const testimonials = {
  title: "Don't Just Take Our Word For It.",
  reviews: [
    {
      id: 1,
      text: "I've finally found my forever moisturizer. Timeless Remedy feels like silk and has given my skin a glow I haven't seen in years. My fine lines are noticeably softer. Worth every penny!",
      author: "Sarah K.",
      age: 52,
      rating: 5,
    },
    {
      id: 2,
      text: "As someone with sensitive skin, I'm wary of anti-aging products. This is a game-changer. It's so gentle, deeply hydrating, and I love knowing it's all-natural. My skin feels calm and looks so much healthier.",
      author: "Maria T.",
      age: 46,
      rating: 5,
    },
    {
      id: 3,
      text: "The texture is divine! It absorbs beautifully and is the perfect base for my makeup. After a month, my skin feels firmer and so much more supple. I'm officially a believer.",
      author: "Jennifer L.",
      age: 60,
      rating: 5,
    },
  ],
  image: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=800&q=80",
};

export const products = [
  {
    id: "timeless-remedy-2oz",
    slug: "timeless-remedy",
    name: "Timeless Remedy – Anti-Aging Moisturizer",
    shortName: "Timeless Remedy",
    description: "A luxurious, all-natural moisturizer crafted to restore, replenish, and reveal your most luminous skin.",
    longDescription: `<h3>The Age-Defying Secret Nature Has Kept for Centuries</h3>
<p>Timeless Remedy is more than just a moisturizer—it's a daily ritual of self-care that honors your skin's natural beauty while providing profound nourishment and protection.</p>

<h3>Key Benefits</h3>
<ul>
<li>Visibly reduces fine lines and wrinkles</li>
<li>Deeply hydrates for 24+ hours</li>
<li>Restores skin's natural radiance</li>
<li>Firms and plumps skin texture</li>
<li>Protects against environmental stressors</li>
</ul>

<h3>Star Ingredients</h3>
<ul>
<li><strong>Bakuchiol:</strong> Nature's gentle retinol alternative for cell renewal</li>
<li><strong>Hyaluronic Acid:</strong> Holds 1000x its weight in water for deep hydration</li>
<li><strong>Rosehip Oil:</strong> Rich in vitamins A & C for brightening</li>
<li><strong>Squalane:</strong> Mimics skin's natural oils for balanced moisture</li>
<li><strong>Vitamin E:</strong> Powerful antioxidant protection</li>
</ul>

<h3>How to Use</h3>
<p>Apply a small amount to cleansed face and neck morning and evening. Gently massage in upward, circular motions until fully absorbed. For best results, use after your favorite serum.</p>`,
    variants: [
      {
        id: "2oz",
        size: "2oz",
        price: 68.00,
        comparePrice: 85.00,
        sku: "TR-2OZ",
        inStock: true,
      },
      {
        id: "5oz",
        size: "5oz",
        price: 128.00,
        comparePrice: 160.00,
        sku: "TR-5OZ",
        inStock: true,
      },
    ],
    images: [
      "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=800&q=80",
      "https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=800&q=80",
      "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=800&q=80",
    ],
    category: "Moisturizers",
    tags: ["anti-aging", "moisturizer", "natural", "cruelty-free"],
    isNew: true,
    onSale: true,
  },
];

export const adminCredentials = {
  username: "admin",
  password: "admin123",
};
